import makeRequest from '@utilities/make-xhr';

export default class SubscribeForm {
    constructor(context, componentName) {
        this.name = componentName;
        this.context = context;

        this.isPromo = this.context.dataset.type === 'promo';
        this.actionURL = this.context.getAttribute('action');
        this.$input = this.context.querySelector('input[name="email"]');

        this.context.addEventListener('submit', (e) => this.sendForm(e), false);
    }

    sendForm(e) {
        e.preventDefault();

        const { value } = this.$input;

        if (value && this.validateEmail(value)) {
            this.showMessage('Подождите...');
            this.sendRequest({
                email: value,
            });
        } else {
            this.showMessage('Укажите ваш email-адрес');
        }
    }

    sendRequest(data) {
        makeRequest('POST', this.actionURL, data)
            .then((resp) => JSON.parse(resp))
            .then(
                (response) => {
                    this[response.error ? 'handleError' : 'handleSuccess'](
                        this.isPromo
                            ? `${response.message ? `${response.message} ` : ''}Ваш промокод: <b>${
                                  response.coupon
                              }</b>`
                            : response.message
                    );

                    try {
                        ga(
                            'send',
                            'event',
                            'subscribeMail',
                            this.isPromo ? 'popup_subscription' : 'podpiska_m'
                        );
                        yaCounter1925770.reachGoal(this.isPromo ? 'popup_subscription' : 'podpiska_m');
                    } catch (error) {
                        console.log(error);
                    }
                },
                (error) => console.log(error)
            );
    }

    handleSuccess(data) {
        this.showMessage(data, 'success');
    }

    handleError(data) {
        this.showMessage(data, 'error');
    }

    showMessage(message, type = 'note') {
        // Remove previous message
        const $prevMessage = this.context.querySelector('.js-message');

        if ($prevMessage) {
            this.context.removeChild($prevMessage);
        }

        // Create new message
        const $message = document.createElement('div');

        $message.className = `js-message alert alert--${type}`;
        $message.innerHTML = `<p class="alert__message">${message}</p>`;

        this.context.insertBefore($message, this.context.firstChild);
    }

    validateEmail(email) {
        const reg = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/;
        return reg.test(email);
    }
}
